<template>
    <div class="upcoming-group-lessons-content card-box-style rounded">
        <div class="main-title border-style d-flex justify-content-between align-items-center">
            <h3>Upcoming Group Lessons</h3>

            <a href="#" class="view-btn">
                View All
            </a>
        </div>

        <div class="row justify-content-center">
            <div class="col-lg-12 col-sm-6">
                <div class="single-group d-flex justify-content-between align-items-center">
                    <div>
                        <h3>UI/UX Design Course</h3>
                        <span class="date">11:00 AM - 01:30 PM</span>
                        <ul class="group-img">
                            <li>
                                <a href="#">
                                    <img src="../../../assets/images/group/group-1.png" alt="group-1">
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <img src="../../../assets/images/group/group-2.png" alt="group-2">
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <img src="../../../assets/images/group/group-3.png" alt="group-3">
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <img src="../../../assets/images/group/group-4.png" alt="group-4">
                                </a>
                            </li>
                            <li>
                                <a href="#" class="total-man">
                                    <img src="../../../assets/images/group/group-5.png" alt="group-5">
                                    <span>32+</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <ul class="add-member-wrap">
                        <li>
                            <div class="dropdown">
                                <button class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <img src="../../../assets/images/icon/dots.svg" alt="dots">
                                </button>

                                <div class="dropdown-menu">
                                    <a class="dropdown-item d-flex align-items-center" href="#">
                                        <i class='bx bx-log-in-circle' ></i>
                                        Leave Group
                                    </a>
                                    <a class="dropdown-item d-flex align-items-center" href="#">
                                        <i class='bx bx-trash'></i> Delete Group
                                    </a>
                                    <a class="dropdown-item d-flex align-items-center" href="#">
                                        <i class='bx bx-block'></i> Block Group
                                    </a>
                                </div>
                            </div>
                        </li>
                        <li>
                            <button class="add-member-btn">
                                Add Member
                            </button>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-12 col-sm-6">
                <div class="single-group d-flex justify-content-between align-items-center">
                    <div>
                        <h3>Fundamental UX Course</h3>
                        <span class="date">01:30 PM - 02:30 PM</span>
                        <ul class="group-img">
                            <li>
                                <a href="#">
                                    <img src="../../../assets/images/group/group-3.png" alt="group-3">
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <img src="../../../assets/images/group/group-4.png" alt="group-4">
                                </a>
                            </li>
                            <li>
                                <a href="#" class="total-man">
                                    <img src="../../../assets/images/group/group-5.png" alt="group-5">
                                    <span>32+</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <ul class="add-member-wrap">
                        <li>
                            <div class="dropdown">
                                <button class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <img src="../../../assets/images/icon/dots.svg" alt="dots">
                                </button>

                                <div class="dropdown-menu">
                                    <a class="dropdown-item d-flex align-items-center" href="#">
                                        <i class='bx bx-log-in-circle' ></i>
                                        Leave Group
                                    </a>
                                    <a class="dropdown-item d-flex align-items-center" href="#">
                                        <i class='bx bx-trash'></i> Delete Group
                                    </a>
                                    <a class="dropdown-item d-flex align-items-center" href="#">
                                        <i class='bx bx-block'></i> Block Group
                                    </a>
                                </div>
                            </div>
                        </li>
                        <li>
                            <button class="add-member-btn">
                                Add Member
                            </button>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-12 col-sm-6">
                <div class="single-group d-flex justify-content-between align-items-center">
                    <div>
                        <h3>UI Motion Fundamental</h3>
                        <span class="date">03:30 PM - 05:30 PM</span>
                        <ul class="group-img">
                            <li>
                                <a href="#">
                                    <img src="../../../assets/images/group/group-4.png" alt="group-4">
                                </a>
                            </li>
                            <li>
                                <a href="#" class="total-man">
                                    <img src="../../../assets/images/group/group-5.png" alt="group-5">
                                    <span>32+</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <ul class="add-member-wrap">
                        <li>
                            <div class="dropdown">
                                <button class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <img src="../../../assets/images/icon/dots.svg" alt="dots">
                                </button>

                                <div class="dropdown-menu">
                                    <a class="dropdown-item d-flex align-items-center" href="#">
                                        <i class='bx bx-log-in-circle' ></i>
                                        Leave Group
                                    </a>
                                    <a class="dropdown-item d-flex align-items-center" href="#">
                                        <i class='bx bx-trash'></i> Delete Group
                                    </a>
                                    <a class="dropdown-item d-flex align-items-center" href="#">
                                        <i class='bx bx-block'></i> Block Group
                                    </a>
                                </div>
                            </div>
                        </li>
                        <li>
                            <button class="add-member-btn">
                                Add Member
                            </button>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-12 col-sm-6">
                <div class="single-group d-flex justify-content-between align-items-center">
                    <div>
                        <h3>UI/UX Design Course</h3>
                        <span class="date">11:00 AM - 01:30 PM</span>
                        <ul class="group-img">
                            <li>
                                <a href="#">
                                    <img src="../../../assets/images/group/group-1.png" alt="group-1">
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <img src="../../../assets/images/group/group-2.png" alt="group-2">
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <img src="../../../assets/images/group/group-3.png" alt="group-3">
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <img src="../../../assets/images/group/group-4.png" alt="group-4">
                                </a>
                            </li>
                            <li>
                                <a href="#" class="total-man">
                                    <img src="../../../assets/images/group/group-5.png" alt="group-5">
                                    <span>32+</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <ul class="add-member-wrap">
                        <li>
                            <div class="dropdown">
                                <button class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <img src="../../../assets/images/icon/dots.svg" alt="dots">
                                </button>

                                <div class="dropdown-menu">
                                    <a class="dropdown-item d-flex align-items-center" href="#">
                                        <i class='bx bx-log-in-circle' ></i>
                                        Leave Group
                                    </a>
                                    <a class="dropdown-item d-flex align-items-center" href="#">
                                        <i class='bx bx-trash'></i> Delete Group
                                    </a>
                                    <a class="dropdown-item d-flex align-items-center" href="#">
                                        <i class='bx bx-block'></i> Block Group
                                    </a>
                                </div>
                            </div>
                        </li>
                        <li>
                            <button class="add-member-btn">
                                Add Member
                            </button>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-12 col-sm-6">
                <div class="single-group d-flex justify-content-between align-items-center">
                    <div>
                        <h3>UI/UX Design Course</h3>
                        <span class="date">11:00 AM - 01:30 PM</span>
                        <ul class="group-img">
                            <li>
                                <a href="#">
                                    <img src="../../../assets/images/group/group-1.png" alt="group-1">
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <img src="../../../assets/images/group/group-2.png" alt="group-2">
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <img src="../../../assets/images/group/group-3.png" alt="group-3">
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <img src="../../../assets/images/group/group-4.png" alt="group-4">
                                </a>
                            </li>
                            <li>
                                <a href="#" class="total-man">
                                    <img src="../../../assets/images/group/group-5.png" alt="group-5">
                                    <span>32+</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <ul class="add-member-wrap">
                        <li>
                            <div class="dropdown">
                                <button class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <img src="../../../assets/images/icon/dots.svg" alt="dots">
                                </button>

                                <div class="dropdown-menu">
                                    <a class="dropdown-item d-flex align-items-center" href="#">
                                        <i class='bx bx-log-in-circle' ></i>
                                        Leave Group
                                    </a>
                                    <a class="dropdown-item d-flex align-items-center" href="#">
                                        <i class='bx bx-trash'></i> Delete Group
                                    </a>
                                    <a class="dropdown-item d-flex align-items-center" href="#">
                                        <i class='bx bx-block'></i> Block Group
                                    </a>
                                </div>
                            </div>
                        </li>
                        <li>
                            <button class="add-member-btn">
                                Add Member
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="calendar-wrap style-three">
            <CalendarWrap />
        </div>
    </div>
</template>

<script>
import CalendarWrap from './CalendarWrap'

export default {
    name: 'UpcomingGroupLessons',
    components: {
        CalendarWrap
    }
}
</script>

<style lang="scss">
.single-group {
	background: #FFFFFF 0% 0% no-repeat padding-box;
	box-shadow: 0px 5px 25px #CAD6F266;
	border: 1px solid #DFE9FF;
	border-radius: 20px;
	padding: 30px;
	margin-bottom: 20px;
	h3 {
		font-size: 16px;
		margin-bottom: 5px;
	}	
	.date {
		font-size: 12px;
		display: block;
		margin-bottom: 12px;
	}
	.group-img {
		padding: 0;
		margin-bottom: 0;
		list-style-type: none;
		li {
			display: inline-block;
			margin-right: -20px;
			a {
				position: relative;
				img {
					border-radius: 50px;
					width: 45px;
					height: 45px;
				}
				&.total-man {
					span {
						position: absolute;
						top: 3px;
						right: 0;
						left: 0;
						font-size: 11px;
						font-weight: 500;
						text-align: center;
						display: block;
						color: var(--white-color);
						z-index: 1;
						&::before {
							content: "";
							position: absolute;
							top: -11px;
							left: 1px;
							width: 40px;
							height: 40px;
							border-radius: 50px;
							background-color: rgba(0, 0, 0, 0.5);
							z-index: -1;
						}
					}
				}
			}
		}
	}
	.add-member-wrap {
		padding: 0;
		margin-bottom: 0;
		list-style-type: none;
		text-align: right;
		li {
			margin-bottom: 20px;
			&:last-child {
				margin-bottom: 0;
			}
			.dropdown {
				position: relative;
				.dropdown-toggle {
					background-color: transparent;
					position: relative;
					&::after {
						display: none;
					}
				}
				.dropdown-menu {
					background: #FFFFFF 0% 0% no-repeat padding-box;
					box-shadow: 0px 5px 25px #CAD6F266;
					border: 1px solid #DFE9FF;
					border-radius: 10PX;
					margin-top: 35px;
					display: block;
					opacity: 0;
					visibility: hidden;
					transition: .3s;
					transform: unset !important;
	
					&.show {
						margin-top: 25px !important;
						opacity: 1;
						visibility: visible;
					}
					.dropdown-item {
						color: var(--heading-color);
						padding: 5px 15px 5px 36px;
						position: relative;
						font: {
							size: 12px;
						};
						i {
							color: #686868;
							transition: var(--transition);
							position: absolute;
							left: 15px;
							top: 6px;
							font: {
								size: 16px;
							};
						}
						&.active, &:active {
							color: var(--heading-color);
							background-color: transparent;
							background-color: #f8f9fa;
						}
						&:hover {
							background-color: transparent;
							color: #db2e2e;
							i {
								color: #db2e2e;
							}
						}
					}
				}
			}
			.add-member-btn {
				background-color: #5C31D6;
				font-size: 12px;
				padding: 8px 10px;
				border-radius: 7px;
				color: var(--white-color);
			}
		}
	}
}
.calendar-wrap {
    background-color: var(--white-color);
    box-shadow: var(--box-shadow);
    padding: 20px;
    border-radius: var(--border-radius);
    &.style-three {
        box-shadow: none;
        padding: 0;
    }
}
.upcoming-group-lessons-content {
    .calendar-header__period-name[data-v-6976f31b] {
        font-weight: 600;
        font-size: 16px !important;
        margin-bottom: 0 !important;
        letter-spacing: -0.32px;
        color: var(--heading-color);
        font-family: var(--body-font-family);
    }
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
    .single-group {
        padding: 15px;
        border-radius: 10px;
        h3 {
            font-size: 14px;
        }
        .group-img {
            li {
                margin-right: -25px;
            }
        }
        .add-member-wrap {
            li {
                .add-member-btn {
                    width: 80px;
                    font-size: 9px;
                    text-align: center;
                }
            }
        }
    }
}

/* Min width 576px to Max width 767px */
@media only screen and (min-width: 576px) and (max-width: 767px) {
    .single-group {
        .group-img {
            li {
                margin-right: -30px;
            }
        }
    }
}

/* Min width 768px to Max width 991px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
    .single-group {
        padding: 15px;
        .group-img {
            li {
                margin-right: -25px;
            }
        }
    }
}

/* Min width 992px to Max width 1199px */
@media only screen and (min-width: 992px) and (max-width: 1199px) {
    .single-group {
        padding: 15px;
        h3 {
            font-size: 14px;
        }
        .group-img {
            li {
                margin-right: -25px;
            }
        }
        .add-member-wrap {
            li {
                .add-member-btn {
                    width: 80px;
                    font-size: 9px;
                    text-align: center;
                }
            }
        }
    }
}

/* Min width 1200px to Max width 1320px */
@media only screen and (min-width: 1200px) and (max-width: 1399px) {
    .single-group {
        padding: 15px;
        h3 {
            font-size: 14px;
        }
        .group-img {
            li {
                margin-right: -29px;
            }
        }
        .add-member-wrap {
            li {
                .add-member-btn {
                    width: 80px;
                    font-size: 9px;
                    text-align: center;
                }
            }
        }
    }
    .upcoming-group-lessons-content {
        .calendar-header__mode-picker[data-v-6976f31b] {
            font-size: 14px;
        }
    }
}

/* Min width 1320px to Max width 1550px */
@media only screen and (min-width: 1320px) and (max-width: 1550px) {
    .single-group {
        padding: 15px;
        .group-img {
            li {
                margin-right: -35px;
            }
        }
    }
}

/* Min width 1400px to Max width 1700px */
@media only screen and (min-width: 1400px) and (max-width: 1700px) {
    .single-group {
        h3 {
            font-size: 14px;
        }
        .group-img {
            li {
                margin-right: -25px;
            }
        }
        .add-member-wrap {
            li {
                .add-member-btn {
                    width: 80px;
                    font-size: 9px;
                    text-align: center;
                }
            }
        }
    }
}
</style>